// extracted by mini-css-extract-plugin
export default {"pageContainer":"page_pageContainer__LR5lt","pageContent":"page_pageContent__9xzoV","pageTitle":"page_pageTitle__S3NxY","skinny":"page_skinny__qZu5W"};